import DtoPiezometerAdditionalMeasures from '../../station/dto/piezometer/DtoPiezometerAdditionalMeasures'

export default class DtoProductionUnitAssociationAdditionalMeasures {
    constructor(object) {
        this.piezometerId = object.piezometerId
        this.measures = object.measures.map(m => new DtoPiezometerAdditionalMeasures(m))
    }
}
